import { Pipe, PipeTransform } from '@angular/core';

import { TipoClassificacao } from '../tipo-classificacao';

@Pipe({
    name: 'tipoClassificacaoCadastroFilter',
    pure: false
})
export class TipoClassificacaoCadastroFilterPipe implements PipeTransform {
    /** Filtra os tipos de classificações pelo seu cadastro */
    transform(entities: TipoClassificacao[], cadastro: number = null): TipoClassificacao[] {
        if (!entities) {
            return [];
        }
        // Retorna todos os tipos de classificações quando não for informado o cadastro a ser filtrado
        if (!cadastro) {
            return entities;
        }

        return entities.filter(entityFilter => entityFilter.cadastro === cadastro);
    }
}
